import React from "react";
import { useLocation } from "react-router-dom";
import { pendingLogo } from "../../../assets/images";

const DeexPending = ({ setOpenSellDPending, setOpenSellFromDeex }: any) => {
  const location = useLocation();

  return (
    <div className="fixed inset-0  flex font-manrope justify-start items-start pt-16 overflow-auto pb-16 bg-[#E7EBEE] dark:bg-primary_dark dark:bg-opacity-95  backdrop-blur-sm">
      <div
        className={` w-11/12 mds:w-8/12 md:7/12 border dark:border-[#303030] bg-white  rounded-xl mx-auto p-6 dark:bg-[#192025]   lgss:w-2/5 xxl:w-1/3 `}
      >
        <div className="w-full flex justify-center px-6 items-center flex-col gap-4">
          <div className="w-[116px] h-[116px]">
            <img src={pendingLogo} className="w-full h-full bg-cover" alt="" />
          </div>
          <h4 className="font-sora font-bold text-gray-900 dark:text-gray-200 text-[24px]">
            Transaction pending
          </h4>
          <h4 className=" font-medium text-gray-500 dark:text-gray-400 text-center text-[15px]">
            We are confirming your sale. Funds will be sent to your Bank account
            immediately after confirmation
          </h4>
        </div>
        <button
          onClick={() => {
            setOpenSellDPending(false);
          }}
          className="mt-16 bg-secondary_button flex justify-center items-center text-white text-[15px] font-medium h-[48px] w-full rounded-xl"
        >
          Done
        </button>
        {location.pathname === "/dashboard" && (
          <button
            onClick={() => {
              setOpenSellDPending(false);
              setOpenSellFromDeex(true);
            }}
            className="mt-4 border-secondary_button border flex justify-center items-center text-secondary_button text-[15px] font-medium h-[48px] w-full rounded-xl"
          >
            Make another transaction
          </button>
        )}
      </div>
    </div>
  );
};

export default DeexPending;
